import { pageBottomClearanceAtom } from "@/atoms/bottom-chrome";
import { useAtomValue } from "jotai";

/** Bottom padding in px that keeps page content clear of the tallest fixed footer and the floating buttons. */
export function usePageBottomInset(): number {
  return useAtomValue(pageBottomClearanceAtom);
}
